import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-md px-2.5 py-1 justify-center text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        outline: 'border border-border text-foreground',
        circular:
          'rounded-full h-5 w-5 p-0 flex items-center justify-center shrink-0 aspect-square bg-primary text-primary-foreground shadow hover:bg-primary/80',
        success: 'bg-train-status-confirmed-fill text-train-status-confirmed-text',
        warning: 'bg-train-status-unconfirmed-fill text-train-status-unconfirmed-text',
        scheduled: 'bg-train-status-schedule-fill text-train-status-schedule-text',
        related: 'bg-train-status-related-to-fill text-train-status-related-to-text',
        destructive: 'bg-destructive-subtle text-destructive-subtle-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
